import Vue from "vue";
import VueAwesomeSwiper from "vue-awesome-swiper";
// 务必在加载 Vue 之后，立即同步设置以下内容
Vue.config.devtools = true;
import "normalize.css/normalize.css"; // A modern alternative to CSS resets
import Element from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import "swiper/dist/css/swiper.css";
import "@/styles/index.scss"; // global css
import "@/styles/tab.scss"; // global css

import App from "./App";
import router from "./router";
import store from "./store";
import i18n from "./locale";
import VueAnalytics from "vue-analytics";

import "./icons/iconfont.css"; //阿里巴巴矢量图标

Vue.config.productionTip = false;

let app = new Vue({
  router,
  i18n,
  store,
  render: (createElement, context) => createElement(App)
}).$mount("#app");
export default app;

Vue.use(VueAwesomeSwiper /* { default global options } */);
Vue.use(Element);
Vue.use(VueAnalytics, {
  id: "UA-6969818-2",
  checkDuplicatedScript: true,
  router,
  autoTracking: {
    pageviewTemplate(route) {
      return {
        page: route.path,
        title: document.title,
        location: window.location.href
      };
    }
  }
});




// WEBPACK FOOTER //
// ./src/main.js